module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "schoolPay"
  }, [_c('div', {
    staticClass: "des"
  }, [_vm._v("校园卡扣款成功")]), _vm._v(" "), _c('div', {
    staticClass: "ac name"
  }, [_vm._v("俺来也")]), _vm._v(" "), _c('div', {
    staticClass: "num ac"
  }, [_c('span', {
    staticClass: "fs-60"
  }, [_vm._v("￥")]), _vm._v(_vm._s(_vm.amount))]), _vm._v(" "), _c('div', {
    staticClass: "btn-yellow suc-btn",
    on: {
      "click": _vm.toOrderDetail
    }
  }, [_vm._v("完成")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-c5dc722a","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/SchoolPaySuc.vue
// module id = 457
// module chunks = 7